import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type TeamDTO = {
    name:string;
    email:string;
    img_url:string;
    title:string
    description:string
}
type TeamResponse = {
    data: object;
} & ApiError;
export const AddTeam = (
    data: TeamDTO
): Promise<TeamResponse> => {
    return axios.post("/team/create", data);
};
